import { useEffect, useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';

import { buscarProveedoresProducto, limpiarProveedoresProducto } from '../../../actions/configuracion';
import { formatNumber } from '../../../utils/generalFunctions';

const formatMoney = (v) => formatNumber(Number(v || 0), 2, '$', '');

/* Igual que en Nueva Venta (SeleccionUbicacionesModal): al elegir un producto se muestran sus
   proveedores para escoger de qué precio parte la línea — aquí solo como referencia, ya que
   el precio queda editable en la tabla del paquete. */
const SeleccionProveedorModal = ({ show, onHide, producto, onConfirm }) => {
    const dispatch = useDispatch();

    const { listado: proveedores } = useSelector(state => state.configuracion?.proveedores_producto || { listado: [] });

    const [proveedorSel, setProveedorSel] = useState(null);

    useEffect(() => {
        if (!show || !producto?._id) return;

        dispatch(buscarProveedoresProducto(producto._id));

        return () => {
            dispatch(limpiarProveedoresProducto());
        };
    }, [show, producto, dispatch]);

    const proveedorOptions = useMemo(() => (
        (Array.isArray(proveedores) ? proveedores : []).map((p, i) => ({
            value: i,
            label: `${p?.proveedor?.nombre || 'Proveedor'} · Venta ${formatMoney(p?.precio_publico)} · Compra ${formatMoney(p?.precio_historico)}`,
            raw: p
        }))
    ), [proveedores]);

    useEffect(() => {
        if (!show) {
            setProveedorSel(null);
            return;
        }
        setProveedorSel(proveedorOptions[0] || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, proveedores]);

    const handleConfirmar = () => {
        onConfirm({
            precio: Number(proveedorSel?.raw?.precio_publico || 0),
            precioCompra: Number(proveedorSel?.raw?.precio_historico || 0)
        });
    };

    const handleSinPrecio = () => {
        onConfirm({ precio: 0, precioCompra: 0 });
    };

    return (
        <Modal show={show} onHide={onHide} size={'lg'}centered>
            <Modal.Header closeButton>
                <Modal.Title>Precio de proveedor</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <div className="fw-semibold">{producto?.nombre || ''}</div>
                    {producto?.codigo_tienda ? (
                        <div className="text-muted" style={{ fontSize: 12 }}>{producto.codigo_tienda}</div>
                    ) : null}
                </div>

                {proveedorOptions.length > 0 ? (
                    <div>
                        <div className="text-muted mb-1" style={{ fontSize: 12 }}>Selecciona proveedor</div>
                        <Select
                            placeholder="Selecciona proveedor"
                            value={proveedorSel}
                            onChange={(opt) => setProveedorSel(opt)}
                            options={proveedorOptions}
                            isSearchable={false}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        />
                        <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                            El precio de venta y de compra del proveedor se usarán como referencia; podrás editarlos después en la tabla.
                        </div>
                    </div>
                ) : (
                    <div className="text-muted" style={{ fontSize: 13 }}>
                        Este producto no tiene proveedores registrados. Se agregará con precio de referencia en $0.00, editable después.
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                {proveedorOptions.length > 0 ? (
                    <Button variant="primary" onClick={handleConfirmar}>
                        Agregar producto
                    </Button>
                ) : (
                    <Button variant="primary" onClick={handleSinPrecio}>
                        Agregar producto
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default SeleccionProveedorModal;
